import { Link } from "react-router-dom";
import { Logo } from "./Logo";

// Lightweight chrome for logged-out public pages (e.g. shared /@username profiles).
export function PublicShell({ children }) {
  return (
    <div className="min-h-screen bg-[#030303]">
      <header className="sticky top-0 z-40 glass border-b border-white/8 h-14 flex items-center justify-between px-4">
        <Logo size={30} to="/" />
        <div className="flex items-center gap-2">
          <Link to="/login" className="text-sm px-4 py-2 rounded-full surface-2 hover:bg-white/10" data-testid="public-login">Log in</Link>
          <Link to="/register" className="text-sm px-4 py-2 rounded-full btn-gold font-semibold" data-testid="public-join">Join VirtuStars</Link>
        </div>
      </header>
      <main className="max-w-[920px] mx-auto">{children}</main>
      <footer className="max-w-[920px] mx-auto px-4 py-10 mt-6 border-t border-white/8 text-center">
        <div className="font-display font-bold text-gold tracking-wide">VIRTUSTARS</div>
        <p className="text-xs text-muted-foreground mt-1">Your Avatar. Your Career. Your Industry.</p>
        <Link to="/register" className="inline-block mt-4 text-sm btn-blue rounded-full px-5 py-2" data-testid="public-cta">Create your free VStar profile</Link>
      </footer>
    </div>
  );
}
